import { COLORS } from '@/styles/colors';
import { flex } from '@/styles/layout';
import { bodySmall } from '@/styles/typography';
import styled from 'styled-components';

export const ThreadWrapper = styled.div`
  ${flex({ flexDirection: 'column' })};
  padding: 14px 16px;
  max-height: 350px;
  min-height: 250px;
  overflow: auto;
  background: ${COLORS.grey[100]};
`;

export const Thread = styled.div`
  ${flex({ flexDirection: 'column' })};
  gap: 12px;
`;

export const Bubble = styled.div<{ $mine?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 3px;
  max-width: 78%;
  padding: 10px 12px;
  border-radius: 12px;
  align-self: ${({ $mine }) => ($mine ? 'flex-end' : 'flex-start')};
  background: ${({ $mine }) => ($mine ? COLORS.grey[900] : COLORS.white)};
  color: ${({ $mine }) => ($mine ? COLORS.white : COLORS.black)};
  border: 1px solid ${({ $mine }) => ($mine ? COLORS.grey[900] : COLORS.grey[400])};
  white-space: pre-line;
  ${bodySmall};
`;
